const Divider = () => {
  return <hr style={{ border: 'none', backgroundColor: 'rgba(0,0,0,0.16)', height: '1px', margin: '32px 0' }} />
}

export default Divider
